var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "Qm_box_sing"
  }, [_c("div", {
    staticClass: "singn_tit"
  }, [_vm._v(_vm._s(_vm.$t("请在下方空白区域进行签名动作，完成签名后点击[上传]按钮")))]), _c("div", {
    staticClass: "QM_tit"
  }, [_c("canvas", {
    ref: "canvas",
    style: {
      width: _vm.canvasWidth + "px",
      height: _vm.canvasHeight + "px"
    },
    on: {
      mousedown: _vm.startDrawing,
      mousemove: _vm.draw,
      mouseup: _vm.stopDrawing
    }
  })]), _c("div", {
    staticClass: "but_box"
  }, [_c("a-button", {
    on: {
      click: _vm.clearCanvas
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("取消")))]), _c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.saveSignature
    }
  }, [_vm._v(_vm._s(_vm.$t("上传")) + " ")])], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };